import styled from 'styled-components';

/**
 * Hide the default LivePerson onClick div, because
 * we be manually triggering the onClick event
 * bound to this div manually.
 */
export const ClickToChat = styled.div`
	display: none;
`;

export const Hr = styled.hr`
	margin-left: -40px;
	margin-right: -40px;
`;

export const CtaContainer = styled.div`
	margin-bottom: -30px;
	display: flex;
	justify-content: space-between;
`;

export const LpLoadingContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const LpLoadingTextContainer = styled.div`
	margin: 20px 0 20px 0;
`;

export const CtaContainerLeft = styled.div`
	display: flex;
	width: 60%;
	justify-content: space-between;
`;

export const CtaContainerRight = styled.div`
	width: 40%;
	justify-content: end;
	display: flex;
`;
